import paths from "@ingka/icons-shared/paths/checkmark-circle";
import { renderPaths } from "../renderPaths.mjs";
var checkmark_circle_default = () => renderPaths(paths);
export {
  checkmark_circle_default as default
};
